import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { ApiModule as ConfigPdfApiModule, BASE_PATH as BASE_PATH_PDF_CONFIG, Configuration as PdfConfig } from '@isophi/isophi-pdfs-api';
import { ApiModule as ConfigApiModule, BASE_PATH as BASE_PATH_CONFIG, Configuration as ConfigConfig } from '@isophi/mng-api';

import { environment } from '../../environments/environment';

export function basePathFactory(): string {
  const baseUrl = environment.api;
  return baseUrl;
}

export function pdfBasePathFactory(): string {
  const baseUrl = environment.pdfApiBase;
  return baseUrl;
}

export function configFactory(): ConfigConfig {
  return new ConfigConfig({
    apiKeys: {},
    // Using headers instead of cookies for workplace context
    // withCredentials: true,
  });
}

export function pdfConfigFactory(): PdfConfig {
  return new PdfConfig({ apiKeys: {} });
}

@NgModule({
  imports: [ConfigApiModule, ConfigPdfApiModule],
  declarations: [],
  exports: [ConfigApiModule, ConfigPdfApiModule],
})
export class ApiModule {
  public static forRoot(): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        { provide: ConfigConfig, useFactory: configFactory },
        { provide: BASE_PATH_CONFIG, useFactory: basePathFactory },
        { provide: PdfConfig, useFactory: pdfConfigFactory },
        { provide: BASE_PATH_PDF_CONFIG, useFactory: pdfBasePathFactory },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' + 'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
